import styled from 'styled-components';
import { Popover } from 'antd';

// newAudit/stayAudit/alreadyAudit    published/offline/modified/editing
// totalCount : 总计
// 草稿/待审核/已审核   已发布/已下架/已修改/修改中
// https://confluence.alo7.cn/pages/viewpage.action?pageId=31164462

const Container = styled.div`
  width: 150px;
  text-align: center;
  margin-left: auto;
  font-size: 16px;
  color: rgba(17, 31, 44, 0.75);
  font-weight: 600;
`;

const STATUS_LIST = [
  { value: 'total', items: [{ label: '全部', value: 'total' }] },
  {
    value: 'draft',
    items: [
      { label: '草稿', value: 'newAudit' },
      { label: '待审核', value: 'stayAudit' },
      { label: '已审核', value: 'alreadyAudit' },
    ],
  },
  {
    value: 'publish',
    items: [
      { label: '已发布', value: 'published' },
      { label: '已下架', value: 'offline' },
      { label: '已修改', value: 'modified' },
      { label: '修改中', value: 'editing' },
    ],
  },
];

const generateTemplate = model => {
  return ({ item }) => {
    return (
      <View key={item.value} plugin="flexbox:la" align="center">
        <View dflex={true} align="center" mr_={14} lh={22}>
          <nx.$rc.list
            items={item.items}
            template={sub => {
              const count = model[sub.item.value + 'Count'];
              return (
                <View key={sub.item.value}>
                  <span>{sub.item.label}</span>
                  <View as="span" c={'#999'} ml={5}>
                    {count}
                  </View>
                </View>
              );
            }}
          />
        </View>
      </View>
    );
  };
};

export default props => {
  const { model } = props;
  if (!model) return null;
  const template = generateTemplate(model);

  return (
    <Container>
      <Popover title={'查看数据'} content={<nx.$rc.list items={STATUS_LIST} template={template} />}>
        <View as="span" cp={true}>
          {model.totalCount}
        </View>
      </Popover>
    </Container>
  );
};
